(function () {
  var wrap = document.querySelector('.product-batterijconditie-root [id^="compare-wrap-"]');
  var bar = document.querySelector('.product-batterijconditie-root .compare-progress-bar');
  if (!wrap || !bar) return;
  var ticking = false;
  function updateBar() {
    var max = wrap.scrollWidth - wrap.clientWidth;
    var p = max > 0 ? (wrap.scrollLeft / max) : 0;
    bar.style.transform = 'translateX(' + (p * 100) + '%)';
    ticking = false;
  }
  wrap.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(updateBar); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', updateBar, { passive: true });
  updateBar();
})();

(function () {
  var toggle = document.querySelector('.product-batterijconditie-root [data-proc-more-toggle]');
  var items = document.querySelector('.product-batterijconditie-root [data-proc-more-items]');
  if (!toggle || !items) return;
  toggle.addEventListener('click', function () {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    items.hidden = expanded;
  });
})();
